/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_Stat_2_ValueInputs */

const tr_landing_intro_stat_2_value = /** @type {(inputs: Landing_Intro_Stat_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7/24`)
};

const en_landing_intro_stat_2_value = /** @type {(inputs: Landing_Intro_Stat_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24/7`)
};

const de_landing_intro_stat_2_value = /** @type {(inputs: Landing_Intro_Stat_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24/7`)
};

const ru_landing_intro_stat_2_value = /** @type {(inputs: Landing_Intro_Stat_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24/7`)
};

/**
* | output |
* | --- |
* | "24/7" |
*
* @param {Landing_Intro_Stat_2_ValueInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_stat_2_value = /** @type {((inputs?: Landing_Intro_Stat_2_ValueInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_Stat_2_ValueInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_stat_2_value(inputs)
	if (locale === "de") return de_landing_intro_stat_2_value(inputs)
	if (locale === "ru") return ru_landing_intro_stat_2_value(inputs)
	return tr_landing_intro_stat_2_value(inputs)
});